import _ from 'lodash'
import { ConvertToMetersObject } from 'admin/lib/Records'

export type MaybeNumber = number | null | undefined | ''

export type Inputs = {
  height: MaybeNumber
  heightUoM: string | null | undefined
  length: MaybeNumber
  lengthUoM: string | null | undefined
  width: MaybeNumber
  widthUoM: string | null | undefined
  quantity: MaybeNumber
}

export type ImperialInputs = {
  heightYards: MaybeNumber
  heightFeet: MaybeNumber
  heightInches: MaybeNumber
  lengthYards: MaybeNumber
  lengthFeet: MaybeNumber
  lengthInches: MaybeNumber
  widthYards: MaybeNumber
  widthFeet: MaybeNumber
  widthInches: MaybeNumber
  quantity: MaybeNumber
}

export const calculateVolume = ({
  height,
  heightUoM,
  length,
  lengthUoM,
  width,
  widthUoM,
  quantity
}: Inputs): MaybeNumber => {
  if (heightUoM === null || heightUoM === undefined || heightUoM === '') {
    heightUoM = 'Millimeter'
  }
  if (lengthUoM === null || lengthUoM === undefined || lengthUoM === '') {
    lengthUoM = 'Millimeter'
  }
  if (widthUoM === null || widthUoM === undefined || widthUoM === '') {
    widthUoM = 'Millimeter'
  }

  if (
    isValidNumber(height) &&
    isValidNumber(length) &&
    isValidNumber(width) &&
    isValidNumber(quantity)
  ) {
    return _.round(
      height *
        ConvertToMetersObject[heightUoM] *
        length *
        ConvertToMetersObject[lengthUoM] *
        width *
        ConvertToMetersObject[widthUoM] *
        quantity,
      5
    )
  }

  return null
}

export const calculateImperialVolume = ({
  heightYards,
  heightFeet,
  heightInches,
  lengthYards,
  lengthFeet,
  lengthInches,
  widthYards,
  widthFeet,
  widthInches,
  quantity
}: ImperialInputs): MaybeNumber => {
  const totalHeightInYards =
    makeValidNumber(heightYards) +
    makeValidNumber(heightFeet) / 3 +
    makeValidNumber(heightInches) / 36
  const totalLengthInYards =
    makeValidNumber(lengthYards) +
    makeValidNumber(lengthFeet) / 3 +
    makeValidNumber(lengthInches) / 36
  const totalWidthInYards =
    makeValidNumber(widthYards) +
    makeValidNumber(widthFeet) / 3 +
    makeValidNumber(widthInches) / 36

  return _.round(
    totalHeightInYards *
      totalLengthInYards *
      totalWidthInYards *
      makeValidNumber(quantity),
    3
  )
}

const isValidNumber = (val: MaybeNumber): val is number => {
  return val != null && val !== undefined && typeof val === 'number' && val >= 0
}

const makeValidNumber = (val: any): number => {
  return isNaN(val) ||
    val === null ||
    val === undefined ||
    typeof val !== 'number' ||
    val < 0
    ? 0
    : val
}
